import './Hint.pcss';
import classnames from 'classnames';
import React, { ReactNode } from 'react';

type Props = {
  children: string | ReactNode | Element[];
  className?: string;
  iconClassName?: string;
};

const Hint = ({ children, className, iconClassName }: Props) => (
  <div className={classnames('input-hint', className)}>
    <span
      className={classnames('input-hint__exclamation-circle', iconClassName)}
    >
      <i className="fas fa-exclamation-circle" />
    </span>
    {children}
  </div>
);

export default Hint;
